'use strict';

angular.module('cloudBillingLegacyFrontend').controller('TenantSettingsCtrlMixin', function($scope, $modal, $eaBackend, TenantId, DataToken) {

  $scope.openTenantSettingsDialog = function() {

    var modalInstance = $modal.open({
      templateUrl: "views/teams/manage/modals/modal_tenant_settings.html",
      controller: 'ModalTenantSettingsCtrl',
      resolve: {
        TenantSettings: function() { 

          $scope.loading = true;
          $scope.loadingMessage = "Requesting tenant settings...";          
          return $eaBackend.dataGetTeamProfile(TenantId, false, DataToken).then(function(teamProfile) {

            var tenantSettings = { General: { Name: teamProfile.Name, NotifyAdmins: false}, AzureAdSettings: undefined, AzureAdGroups: undefined }

            // try to load the add connections
            return $eaBackend.dataGetAADConnections(TenantId, DataToken).then(function (connections) {
              if (!connections || connections.length === 0) { 
                $scope.loading = false;
                $scope.loadingMessage = undefined;
                return tenantSettings;              
              } else {

                // set the aad settings
                tenantSettings.AzureAdSettings = connections[0];

                // load the graph groups
                $scope.loading = true;
                $scope.loadingMessage = "Requesting available groups in assosciated directory...";                          
                return $eaBackend.dataGetAADConnectionGroups(TenantId, connections[0].TenantId, DataToken).then(function(groups) {

                  // order the groups by name
                  groups.sort(function(a, b){
                    return a.GroupName.toLowerCase().localeCompare(b.GroupName.toLowerCase());
                  });

                  // assign the ordered array
                  tenantSettings.AzureAdGroups = groups;

                  tenantSettings.AzureAdGroups.forEach(function(group) {
                    if (connections[0] && connections[0].RequiredGroup && connections[0].RequiredGroup.GroupId == group.GroupId) {
                      tenantSettings.AzureAdSettings.RequiredGroup = group;
                    }
                  })

                  $scope.loading = false;
                  $scope.loadingMessage = undefined;

                  // done
                  return tenantSettings;
                })
              }              
            })
          })  
        }
      }
    });

    // returns a promise
    return modalInstance.result.then(function(result) {

      $scope.loading = true;
      $scope.loadingMessage = "Updating tenant settings..."
                
      var updateDataPromise = $eaBackend.dataUpdateTeamProfile(TenantId, result.tenantSettings.General, DataToken);
      
      // done when we have no aad settings
      if (!result.tenantSettings.AzureAdSettings) { return updateDataPromise; }    
      return updateDataPromise.then(function() {
            
        // check if we need to delete the link or update it 
        if (result.deleteLink) {          
          $scope.loadingMessage = "Deleting directory configuration..."
          return $eaBackend.dataDeleteAADConnection(TenantId, result.tenantSettings.AzureAdSettings.TenantId, DataToken);
        } else {          
          $scope.loadingMessage = "Updating directory configuration..."
          return $eaBackend.dataRegisterAADConnection(TenantId, result.tenantSettings.AzureAdSettings, DataToken);              
        }
      });
    });
  }
});
